import React from 'react';
import ErrorPage from '../ErrorPage';
import { generateErrorLogger } from '../../../utilities/loggers';

const logError = generateErrorLogger('Global Error Boundary', {});

type OwnProps = {
  children: React.ReactNode;
};

type OwnState = {
  hasError: boolean;
};

export default class ErrorBoundary extends React.Component<OwnProps, OwnState> {
  constructor(props: OwnProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logError(error, info as unknown as Record<string, unknown>);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <ErrorPage />;
    }
    return children;
  }
}
